export const base_url = process.env.VUE_APP_BASE_URL;